var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowInCircleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.399,
    height: 12.399,
    viewBox: "0 0 12.399 12.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(-770.429 -443.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M6.2,0A6.2,6.2,0,1,1,0,6.2,6.2,6.2,0,0,1,6.2,0Z",
    transform: "translate(782.828 455.699) rotate(180)",
    fill: "#025a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "back",
    d: "M2.48.1a.327.327,0,0,1,.462.462L1.021,2.48a.327.327,0,0,0,0,.462L2.943,4.865a.327.327,0,0,1-.462.462L.1,2.943a.327.327,0,0,1,0-.462Z",
    transform: "translate(778.148 452.212) rotate(180)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowInCircleRight);
export default __webpack_public_path__ + "static/media/Arrow-in-circle-right.bbb5387628ad91b80102ca8080ccc450.svg";
export { ForwardRef as ReactComponent };